import { customization } from '@yola/ws-sdk';
import { FALLBACK_COLOR_SCHEME } from '../constants/color-schemes';

const CUSTOM_LIGHT_PREFIX = `${customization.constants.CUSTOM_COLOR_SCHEME_PREFIX}light-`;
const CUSTOM_DARK_PREFIX = `${customization.constants.CUSTOM_COLOR_SCHEME_PREFIX}dark-`;

const getFallbackColorScheme = (schemeId) => {
  if (schemeId.startsWith(CUSTOM_LIGHT_PREFIX)) return 'ws-light-1';
  if (schemeId.startsWith(CUSTOM_DARK_PREFIX)) return 'ws-dark-0';
  return FALLBACK_COLOR_SCHEME;
};

export default getFallbackColorScheme;
